<!-- 全支付介紹：/about -->
<template>
  <div class="layout_wrapper layout_wrapper_about">
    <section class="about_us">
      <div class="container">
        <h2 class="main_title">
          關於我們
        </h2>

        <p class="desc">
          我們的願景是讓行動支付不僅僅是一種支付方式，而是成為日常生活的
          <span class="tag">樂趣與便利的同義詞</span>
          。我們將通過不斷的創新和突破，引領支付技術的未來，使每一次的支付都
          <span class="tag">快捷、安全</span>
          ，且充滿樂趣。我們承諾將行動支付融入每個角落，不論是咖啡店的晨間咖啡，還是線上的突發購物，都將是一次輕鬆愉快的體驗。一起，讓生活更簡單，每一天都充滿可能！
        </p>
      </div>
    </section>

    <section
      ref="main"
      class="team"
    >
      <div class="container">
        <div class="team_desc">
          <h2 class="main_title">
            團隊介紹
          </h2>

          <p class="desc">
            各團隊之間依據職能專業分工，同時發揮團隊合作的精神，致力創造一個多元嶄新的支付生態圈。
          </p>
        </div>

        <div class="team_department">
          <div
            v-for="dept in deptList"
            :key="dept.id"
            :class="['team_department_item', `team_department_item_${dept.id}`]"
          >
            <img :src="require('@/assets/imgs/aboutMe/bg.svg')">

            <div class="team_department_title_en">
              {{ dept.title_en }}
            </div>

            <div class="team_department_info">
              <div class="team_department_logo">
                <img
                  :src="require(`@/assets/imgs/aboutMe/dept-${dept.id}.svg`)"
                >
              </div>

              <h2 class="team_department_title">
                {{ dept.title }}
              </h2>

              <p class="team_department_desc">
                {{ dept.desc }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="team_slide">
        <Swiper
          slides-per-view="auto"
          :autoplay="{
            disableOnInteraction: false,
            delay: 3000
          }"
          :loop="true"
          :space-between="30"
          :navigation="{
            nextEl: '.team_swiper_navigation_next',
            prevEl: '.team_swiper_navigation_prev'
          }"
          :breakpoints="{
            320: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 'auto',
            }
          }"
          @swiper="setTeamSwiper"
        >
          <SwiperSlide
            v-for="(dept, idx) in deptList"
            :key="idx"
            class="team_department_item"
          >
            <img
              v-if="isMobile"
              :src="getMobileImage(dept.id)"
              style="width: 100%; height: auto;"
            >

            <template v-else>
              <img :src="require('@/assets/imgs/aboutMe/bg.svg')">

              <div class="team_department_title_en">
                {{ dept.title_en }}
              </div>

              <div class="team_department_info">
                <div class="team_department_logo">
                  <img
                    :src="require(`@/assets/imgs/aboutMe/dept-${dept.id}.svg`)"
                  >
                </div>

                <h2 class="team_department_title">
                  {{ dept.title }}
                </h2>

                <p class="team_department_desc">
                  {{ dept.desc }}
                </p>
              </div>
            </template>
          </SwiperSlide>
        </Swiper>

        <div class="team_slide_navigation_block">
          <div class="team_swiper_navigation team_swiper_navigation_prev" />
          <div class="team_swiper_navigation team_swiper_navigation_next" />
        </div>
      </div>
    </section>

    <section class="milestone">
      <div class="container">
        <div class="milestone_select">
          <select
            v-model="milestoneMonthVal"
            class="milestone_select_month"
          >
            <option
              v-for="month in milestonesSortKeys"
              :key="month"
              :value="month"
            >
              {{ month }}
            </option>
          </select>
        </div>

        <div class="milestone_timeline">
          <div
            v-for="month in milestonesSortKeys"
            :key="month"
            :data-year="month"
            :class="['milestone_timeline_month', `milestone_timeline_month_${month}`,
                     {'milestone_timeline_month_show': milestoneMonthVal === month}]"
          >
            <h3 class="milestone_timeline_title">
              {{ month }}
            </h3>

            <div class="milestone_timeline_list">
              <div
                v-for="(item, idx) in milestonesData[month]"
                :key="idx"
                class="milestone_timeline_item"
              >
                <div :class="['milestone_timeline_item_block', {'milestone_timeline_item_block_no_text': !item.text}]">
                  <div
                    v-if="item.text && item.icon"
                    class="milestone_timeline_item_icon"
                  >
                    <img :src="item.icon">
                  </div>

                  <div
                    v-else-if="item.text"
                    class="milestone_timeline_item_icon"
                  >
                    <img :src="require('@/assets/imgs/aboutMe/milestone_icon@3x.png')">
                  </div>

                  <div class="milestone_timeline_item_info">
                    <div class="milestone_timeline_item_month">
                      {{ item.month }}月
                    </div>

                    <h4 class="milestone_timeline_item_title">
                      {{ item.title }}
                    </h4>

                    <p class="milestone_timeline_item_text">
                      {{ item.text }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="milestone_menu_block">
          <ul class="milestone_menu">
            <li
              v-for="month in milestonesSortKeys"
              :key="month"
              :class="['milestone_menu_link', {'milestone_menu_link_active': milestoneMonthScrollVal === month}]"
              @click="goToMonth($event, month)"
            >
              {{ month }}
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onUnmounted, nextTick } from 'vue';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SwiperCore, { Autoplay, Mousewheel, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';

export default {
  name: 'About',
  components: {
    Swiper,
    SwiperSlide
  },
  setup () {
    SwiperCore.use([Autoplay, Mousewheel, Navigation]);
    const deptsPosY = [];
    let deptsPosX = [];
    let ctx = null;
    let isGsapSetting = false;
    let teamSwiperEl = null;

    const main = ref();
    const content = ref();
    const isTeamSectionScrollLeave = ref(false);
    const milestoneMonthVal = ref('2024');
    const milestoneMonthScrollVal = ref('2024');
    const isMobile = ref(false);
    const deptList = ref([
      {
        id: 1,
        title: '策略部',
        title_en: 'SD',
        desc: '公司的引擎！致力於營業額增長及持續推動服務，確保部門資源整合和溝通無阻，讓公司保持領先地位！'
      },
      {
        id: 2,
        title: '業務部',
        title_en: 'BD',
        desc: '秉持熱忱的心去開發市場每一角落，提升全支付的店家數，解決店家使用問題，讓會員有更便利的消費場域！'
      },
      {
        id: 3,
        title: '行銷部',
        title_en: 'Marketing',
        desc: '用多元活潑的方式傳遞全支付產品價值與服務，擬定宣傳策略，增加曝光，打造品牌形象、活絡社群經營。'
      },
      {
        id: 4,
        title: '行政部',
        title_en: 'Administrative',
        desc: '發放薪資、召募新夥伴，從辦公室環境到日常大小事都全力支援。我們是公司運作的幕後推手，也是讓同仁安心工作的後盾。'
      },
      {
        id: 5,
        title: '研發技術部',
        title_en: 'RD',
        desc: '功能皆自行開發，最堅強的後援！因應迅速成長的交易量導入多項open source solution，以處理高併發高流量的金流平台。'
      },
      {
        id: 6,
        title: '營運管理部',
        title_en: 'OP',
        desc: '會員黏著靠我們、品牌人氣找我們、店家問題問我們！行銷、場域、商圈一條龍服務，讓整個城市都感受到全支付的熱度。'
      },
      {
        id: 7,
        title: '產品部',
        title_en: 'Product',
        desc: '充滿樂趣和挑戰的團隊，透過產品經理的奇思妙想及設計師的創意加持，排除萬難把想像打造成令人驚艷的產品！'
      },
      {
        id: 8,
        title: '財務部',
        title_en: 'Finance',
        desc: '如同營養師管理著公司的財務健康，從會計稅務、資金管理到財務規劃與分析等，深深影響經營策略和決策！'
      },
      {
        id: 9,
        title: '資訊維運部',
        title_en: 'IT',
        desc: '上雲端系統、連設備機房，一切需要用到電的都找資訊維運部！'
      },
      {
        id: 10,
        title: '風險管理部',
        title_en: 'Risk Management',
        desc: '公司的Goalkeeper！面對來自四面八方的風險襲擊，專注於監控與評估、透過系統化查核程序，堅守公司安全發展！'
      },
      {
        id: 11,
        title: '法務部',
        title_en: 'Legal',
        desc: '法務：處理公司一切與權利義務有關的法律行為；法遵：確認公司營業行為如何遵循法律。'
      },
      {
        id: 12,
        title: '稽核室',
        title_en: 'Auditorial Room',
        desc: '公司的評估診斷系統，檢視所有部門是否依權責各司其職、符合主管機關相關規範辦理，盡全力守護著全支付！'
      }
    ]);
    const milestonesData = reactive({
      2024: [
        {
          month: 2,
          title: '日本跨境支付服務上線',
          text: '同時支援「正掃」及「反掃」兩種掃碼模式',
          icon: ''
        },
        {
          month: 3,
          title: 'TWQR上線',
          text: '首家電支業者支援信用卡交易',
          icon: ''
        },
        {
          month: 5,
          title: '開放玉山銀行信用卡繳納綜所稅',
          text: '首日交易額破億',
          icon: ''
        },
        {
          month: 5,
          title: '元大投信金融服務上線',
          text: '',
          icon: ''
        },
        {
          month: 6,
          title: '榮獲第十八屆金炬獎',
          text: '',
          icon: ''
        },
        {
          month: 7,
          title: '開放信用卡繳全台18縣市路邊停車費',
          text: '',
          icon: ''
        },
        {
          month: 8,
          title: '全支付會員突破500萬人',
          text: '',
          icon: ''
        },
        {
          month: 9,
          title: '新北市校園通App繳費服務上線',
          text: '提供學校、家長與學生更便捷的支付方式',
          icon: ''
        },
        {
          month: 11,
          title: '獲頒2024年財訊金融獎之「消費金融品牌獎」領域「行動支付客戶推薦優質獎」',
          text: '',
          icon: ''
        },
        {
          month: 11,
          title: '榮獲2024年國家品牌玉山獎、最佳人氣品牌獎',
          text: '',
          icon: ''
        },
        {
          month: 12,
          title: '與Netflix跨界合作「全聯經濟魷戲」',
          text: '推全支付專屬活動',
          icon: ''
        },
        {
          month: 12,
          title: '全支付跨年夜驚喜撒紅包',
          text: '「台北最High新年城」百萬紅包瘋狂送',
          icon: ''
        }
      ],
      2023: [
        {
          month: 1,
          title: '開放18歲以上成年人註冊電支會員',
          text: '',
          icon: ''
        },
        {
          month: 1,
          title: '通路拓展怡和餐飲集團雙品牌-肯德基及必勝客',
          text: '',
          icon: ''
        },
        {
          month: 3,
          title: '會員數突破3百萬人',
          text: '',
          icon: ''
        },
        {
          month: 4,
          title: '上線「中山醫大附設醫院」電支繳費',
          text: '',
          icon: ''
        },
        {
          month: 6,
          title: '金融服務「電支雞」上線',
          text: '',
          icon: ''
        },
        {
          month: 8,
          title: '跨行轉帳服務上線',
          text: '',
          icon: ''
        },
        {
          month: 8,
          title: '會員數突破400萬人',
          text: '',
          icon: ''
        },
        {
          month: 8,
          title: '代理收付額月增加9.89億',
          text: '業界最高',
          icon: ''
        },
        {
          month: 9,
          title: '上線滿週年',
          text: '',
          icon: ''
        },
        {
          month: 12,
          title: '通路數突破20萬',
          text: '',
          icon: ''
        },
        {
          month: 12,
          title: '連結帳戶銀行達21家',
          text: '',
          icon: ''
        }
      ],
      2022: [
        {
          month: 9,
          title: '全支付正式對外上線',
          text: '與百大實體通路品牌攜手合作支付，同時推出線上繳費服務',
          icon: ''
        },
        {
          month: 9,
          title: '與全聯合作門市現金儲值',
          text: '於全聯福利中心APP置入SDK提供PX Pay會員全支付付款服務',
          icon: ''
        },
        {
          month: 9,
          title: '上線僅18天註冊會員數即突破1百萬',
          text: '最短時間達到百萬會員的電子支付機構',
          icon: ''
        },
        {
          month: 9,
          title: '上線首月累積交易金額超過20億',
          text: '',
          icon: ''
        },
        {
          month: 10,
          title: '註冊會員突破2百萬',
          text: '',
          icon: ''
        },
        {
          month: 12,
          title: '元大銀行、兆豐銀行上線',
          text: '可連結銀行帳戶達15家',
          icon: ''
        }
      ],
      2021: [
        {
          month: 6,
          title: '取得金管會核發專營電子支付機構業務的許可函',
          text: '',
          icon: ''
        }
      ],
      2020: [
        {
          month: 9,
          title: '成立全支付股份有限公司',
          text: '',
          icon: ''
        }
      ]
    });

    const milestonesSortKeys = computed(() => Object.keys(milestonesData).sort((a, b) => b - a));

    const goToMonth = (e, month) => {
      e.preventDefault();
      const targetElement = document.querySelector(`.milestone_timeline_month_${month}`);

      if (targetElement) {
        const navbarHeight = document.querySelector('.navbar').getBoundingClientRect().height;
        const duration = 500;
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - navbarHeight;
        const startPosition = window.scrollY;

        requestAnimationFrame(scrollAnimation(startPosition, targetPosition, duration));
      }
    };

    const scrollAnimation = (startPosition, targetPosition, duration) => {
      let startTime = null;

      return function animate (currentTime) {
        startTime = startTime ?? currentTime;

        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        window.scrollTo(0, startPosition + (targetPosition - startPosition - 40) * progress);

        if (timeElapsed < duration) requestAnimationFrame(animate);
      };
    };

    const getMobileImage = (id) => {
      try {
        return require(`@/assets/imgs/aboutMe/dept-card-m/dept-${id}.svg`);
      } catch (e) {
        return require('@/assets/imgs/aboutMe/bg.svg');
      }
    };

    const setScreenResize = () => {
      if (window.innerWidth <= 743) { // mobile
        if (ctx) ctx.revert();

        gsap.set('.team_department', { opacity: 0, display: 'none' });
        isGsapSetting = false;
        isMobile.value = true;
        window.removeEventListener('scroll', setScrollMilestoneActive);
      } else if (!isGsapSetting) { // desktop
        gsap.set('.team_department', { opacity: 1, display: 'block' });

        ctx = gsap.context(() => {
          deptList.value.forEach((dept, idx) => {
            const defaultPosition = { x: -62, y: 680 };
            const positionList = {
              0: { y: 80 },
              1: { x: -162 },
              2: { x: 0 },
              3: { x: -255 },
              4: { x: -62 }
            };

            gsap.set(`.team_department .team_department_item_${dept.id}`, { ...defaultPosition, ...positionList[idx] });
            gsap.set('.team .team_slide', { autoAlpha: 0, duration: 0 });
          });

          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.team .container',
              pin: true,
              start: '-120 top',
              end: '+=5000',
              scrub: true,
              ease: 'power3.out',
              markers: false,
              invalidateOnRefresh: true
            }
          });

          tl.to('.team_department .team_department_item:nth-child(-n+5)', {
            y: function (index, target, targets) {
              if (index === 0) return -20;

              return index * -430;
            },
            stagger: 0.5
          });

          tl.to('.team_desc', {
            y: -1000
          }, 'step2');

          tl.to('.team_department .team_department_item', {
            x: function (index, target, targets) {
              if (index === 0) {
                deptsPosX = [];
                deptsPosX.push(-window.innerWidth + 392 + ((window.innerWidth - 1140) / 2));

                return -window.innerWidth + 392 + ((window.innerWidth - 1140) / 2);
              }

              const result = deptsPosX[index - 1] + 392 + 30;
              deptsPosX.push(result);

              return result;
            },
            y: function (index, target, targets) {
              if (index === 0) {
                deptsPosY.push(50);

                return 50;
              }

              const result = deptsPosY[index - 1] - 493;
              deptsPosY.push(result);

              return result;
            }
          }, 'step2');

          tl.to('.team .container', {
            autoAlpha: 0,
            duration: 0
          }, 'step3');

          tl.to('.team .team_slide', {
            autoAlpha: 1,
            duration: 0
          }, 'step3');

          tl.call(() => {
            teamSwiperEl.slideTo(0, 0);
          }, null, 'step3');
        }, main.value);

        isGsapSetting = true;
        isMobile.value = false;
        window.addEventListener('scroll', setScrollMilestoneActive);
      }
    };

    const setScrollMilestoneActive = () => {
      const currentScroll = document.documentElement.scrollTop + 50;
      const sections = document.querySelectorAll('.milestone_timeline_month');

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.offsetHeight;

        if (currentScroll >= sectionTop && currentScroll < sectionTop + sectionHeight) {
          milestoneMonthScrollVal.value = section.dataset.year;
        }
      });
    };

    const setTeamSwiper = (swiper) => {
      teamSwiperEl = swiper;
    };

    onMounted(() => {
      gsap.registerPlugin(ScrollTrigger);

      nextTick(() => {
        window.addEventListener('scroll', function () {
          console.log(isTeamSectionScrollLeave.value);
        });
        window.addEventListener('resize', setScreenResize);
        setScreenResize();
      });
    });

    onUnmounted(() => {
      ctx.revert();
    });

    return {
      main,
      content,
      deptList,
      isTeamSectionScrollLeave,
      milestonesData,
      milestoneMonthVal,
      milestoneMonthScrollVal,
      goToMonth,
      milestonesSortKeys,
      setTeamSwiper,
      isMobile,
      getMobileImage
    };
  }
};
</script>

<style lang="scss">
@import '@/scss/common/common.scss';

.team {
  .team_department_item {
      position: relative;
      height: 493px;
      overflow: hidden;
      width: 392px;

      .team_department_info {
        position: absolute;
        left: 0;
        top: 0;
        width: calc(100% - 91px);
        height: 100%;
      /*   outline: 1px solid red; */
        display: flex;
        flex-direction: column;
        padding: 50px 30px;
      }

      .team_department_logo {
        margin: 0 auto;
        margin-bottom: 20px;
        text-align: center;
        width: 100%;
      }

      .team_department_title_en {
        font-weight: bold;
        color: $primary_color;
        font-size: 45px;
        line-height: 1.44;
        position: absolute;
        left: 305px;
        top: 50px;
        transform: rotate(90deg) translateY(-100%);
        transform-origin: left top;
        white-space: nowrap;
      }

      .team_department_title {
        @include font-size-bold-24;

        margin: 0;
        margin-bottom: 20px;
      }

      .team_department_desc {
        @include font-size-16;

        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        max-height: 89px;
        overflow: hidden;
      }
    }
}

@media (min-width: 768px) {
  .team {
    .team_department_item {
      width: 392px !important;
    }
  }
}

@include RWD_414 {
  .team {
    .team_department_item {
      height: 100%
    }
  }
}
</style>

<style scoped lang="scss">
@import '@/scss/common/common.scss';
.layout_wrapper_about {
  p {
    margin: 0px;
  }

  .container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1140px;
    padding: 100px 0px;
  }

  .about_us {
    .container {
      padding-left: 50px;
      padding-right: 50px;
    }

    .main_title {
      @include font-size-bold-54;

      color: $black;
      margin: 0px 0px 20px;
      user-select:none;
      -webkit-user-select:none;
      -moz-user-select:none;
    }

    .desc {
      font-size: 24px;
      font-weight: bold;
      line-height: 1.88;
      letter-spacing: 0.8px;
      user-select:none;
      -webkit-user-select:none;
      -moz-user-select:none;
    }

    .tag {
      background: $news_color;
    }
  }

  .team {
    overflow: hidden;
    position: relative;

    .container {
      padding-left: 30px;
      padding-right: 30px;
      padding-bottom: 390px;
    }

    .team_desc {
      width: 322px;
    }

    .main_title {
      @include font-size-bold-40;

      color: $black;
      margin: 0px 0px 20px;
    }

    .desc {
      color: $mono_80;
      font-size: 24px;
      line-height: 1.46;
    }

    .team_department {
      height: 493px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .team_slide {
      bottom: 0;
      left: 0;
      position: absolute;
      width: 100%;

      .team_slide_navigation_block {
        display: flex;
        justify-content: center;
        margin: 50px 0px;

        .team_swiper_navigation {
          background: url('~@/assets/imgs/homepage/arrow-left.svg') no-repeat center center $primary_color;
          border-radius: 50%;
          cursor: pointer;
          height: 66px;
          width: 66px;
        }

        .team_swiper_navigation_next {
          margin-left: 50px;
          transform: rotate(180deg);
        }
      }
    }
  }

  .milestone {
    background: $mono_10;

    .container {
      display: flex;
      flex-direction: column;
    }

    .milestone_select {
      display: none;
    }

    .milestone_timeline {
      margin-bottom: 100px;
    }

    .milestone_timeline_month {
      align-items: center;
      display: flex;
      flex-direction: column;
      position: relative;

      &:not(:last-child) {
        padding-bottom: 50px;
      }

      &:before {
        bottom: 0px;
        background-color: $white;
        content: "";
        left: 50%;
        position: absolute;
        top: 64px;
        transform: translateX(-50%);
        width: 10px;
      }
    }

    .milestone_timeline_title {
      background: $black;
      border-radius: 38px;
      color: $white;
      display: inline-block;
      font-size: 30px;
      line-height: 44px;
      margin: 0px;
      margin-bottom: 50px;
      padding: 10px 50px;
    }

    .milestone_timeline_list {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    .milestone_timeline_item {
      overflow: hidden;

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      &:nth-child(even) {
        display: flex;
        justify-content: flex-end;

        .milestone_timeline_item_block {
          margin-right: calc(50% + 80px);
          margin-left: 0px;

          &::before {
            left: auto;
            right: -80px;
          }
        }
      }
    }

    .milestone_timeline_item_block {
      background: $white;
      border-radius: 20px;
      display: flex;
      max-width: 434px;
      margin-left: calc(50% + 80px);
      position: relative;
      padding: 30px;
      width: auto;

      &::before {
        background: $white;
        content: '';
        height: 10px;
        left: -80px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 80px;
      }

      &_no_text {
        .milestone_timeline_item_info {
          align-items: center;
          display: flex;
        }

        .milestone_timeline_item_month {
          margin-bottom: 0px;
          margin-right: 20px;
        }

        .milestone_timeline_item_title {
          margin: 0px;
        }
      }
    }

    .milestone_timeline_item_icon {
      align-items: center;
      border-radius: 50%;
      color: $mono_20;
      display: flex;
      justify-content: center;
      height: 74px;
      margin-right: 20px;
      overflow: hidden;
      width: 74px;

      img {
        width: 70px;
        height: auto;
      }
    }

    .milestone_timeline_item_info {
      flex: 1;
    }

    .milestone_menu_block {
      bottom: 50px;
      left: 50%;
      position: sticky;
    }

    .milestone_menu {
      border-radius: 78px;
      box-shadow: 0 2px 4px 0 #ddd;
      background: $white;
      display: flex;
      list-style: none;
      margin: 0px;
      padding: 0px;
      max-width: 1140px;
    }

    .milestone_timeline_item_month {
      @include font-size-bold-18;

      background: $primary_color;
      border-radius: 19px;
      color: $black;
      display: inline-block;
      height: 38px;
      margin-bottom: 10px;
      min-width: 74px;
      padding: 6px 17px;
      text-align: center;
    }

    .milestone_timeline_item_title {
      @include font-size-bold-18;

      color: $black;
      margin-top: 0;
      margin-bottom: 10px;
    }

    .milestone_timeline_item_text {
      @include font-size-18;

      color: $mono_80;
      margin-top: 0;
    }

    .milestone_menu_link {
      @include font-size-bold-24;

      cursor: pointer;
      flex: 1;
      line-height: 35px;
      padding: 30px;
      text-align: center;

      &_active {
        color: $primary_color;
      }
    }
  }
}

@include RWD_768 {
  .layout_wrapper_about {
    .milestone {
      .milestone_menu_block {
        padding: 0 30px;
      }
    }
  }
}

@include RWD_414 {
  .layout_wrapper_about {
    .container {
      max-width: 1140px;
      padding: 30px;
    }

    .about_us {
      .container {
        padding-left: 30px;
        padding-right: 30px;
      }

      .main_title {
        @include font-size-bold-36;
      }

      .desc {
        font-size: 18px;
        line-height: 30px;
        letter-spacing: 0px;
      }
    }

    .team {
        .container {
          padding-bottom: 30px;
        }

        .team_slide {
          position: relative;
          padding: 0px 30px 30px;

          .team_department_item {
            width: 100%;
            height: 100%;
          }

          .team_slide_navigation_block {
            margin: 30px 0px 0px;

            .team_swiper_navigation {
              background-size: 18px;
              height: 50px;
              width: 50px;
            }

            .team_swiper_navigation_next {
              margin-left: 100px;
            }
          }
        }

        .team_desc {
          width: 100%;
        }

        .main_title {
          @include font-size-bold-36;
        }

        .desc {
          font-size: 18px;
          line-height: 26px;
        }

        .team_department {
          display: flex;
          height: auto;
          overflow: auto;
          position: relative;
          right: auto;
          top: auto;
          width: 100%;
        }

        .team_department_item {
          height: auto;
          overflow: initial;

          &:not(:last-child) {
            margin-right: 30px;
          }
        }
      }

    .milestone {
      .container {
        padding-top: 50px;
        padding-bottom: 80px;
      }

      .milestone_select {
        display: block;
        margin-bottom: 50px;
        position: relative;

        &::before {
          background: url('../assets/imgs/arrow-down.svg') center center no-repeat;
          background-size: contain;
          content: '';
          height: 24px;
          right: 20px;
          position: absolute;
          top: 14px;
          width: 24px;
        }
      }

      .milestone_select_month {
        @include font-size-bold-16;

        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border-radius: 27px;
        border: 2px solid $mono_20;
        background: #fff;
        color: $black;
        padding: 14px 77px 14px 32px;
        width: 100%;

        &:focus {
          outline: none;
        }
      }

      .milestone_timeline {
        margin-bottom: 0;
      }

      .milestone_timeline_month {
        display: none;

        &_show {
          display: flex;
          padding-bottom: 0 !important;
        }

        &::before {
          display: none;
        }
      }

      .milestone_timeline_title {
        font-size: 24px;
        line-height: 35px;
      }

      .milestone_menu_block {
        display: none;
      }

      .milestone_timeline_item_block {
        flex-direction: row-reverse;
        max-width: 100%;
        margin: 0px !important;
        width: 100%;

        .milestone_timeline_item_icon {
          margin-left: 20px;
          margin-right: 0px;
        }

        &::before {
          display: none;
        }
      }
    }
  }
}
</style>
